module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Bible Translations"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexviii",
      "title": "xviii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexix",
      "title": "xix"
    }
  })]), _vm._v(" "), _c('table', {
    staticClass: "no-lines"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ESV")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("English Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("KJV")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("King James Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Septuagint")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("NRSV")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("New Reivsed Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Vg")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Vulgate")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36765da8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/bibletransl.vue
// module id = 78
// module chunks = 0